export default {"src":"/_next/static/image/public/images/ic_cod_dark_grey.7ffb229462ee193ffb082e0e814e6516.svg","height":16,"width":29};